<script setup lang="ts">
// Wraps a label + input slot + optional hint / error. The slot is scoped and
// receives the auto-generated id so leaf code can bind `:id` and `for` stays
// correct without hand-managed uniqueness.

import { useId } from 'vue'

withDefaults(defineProps<{
  label:     string
  hint?:     string
  error?:    string | null
  required?: boolean
  id?:       string
}>(), { required: false })

const autoId = useId()
</script>

<template>
  <div class="field">
    <label
      :for="id ?? autoId"
      class="field-label"
      :class="{ 'field-required': required }"
    >{{ label }}</label>

    <slot :id="id ?? autoId" />

    <p v-if="hint && !error" class="field-hint">{{ hint }}</p>
    <p v-if="error" class="field-error" role="alert">{{ error }}</p>
  </div>
</template>
